export const getSourcesColumns = ({ t }) => [
  {
    title: t('Source'),
    dataIndex: 'name',
    key: 'name',
    ellipsis: true,
    width: 100,
    render: (v, all) => {
      if (all.empty) {
        return <div className="daf-default-cell md" />;
      }

      return v;
    }
  },
  {
    title: t('Origin'),
    dataIndex: 'origin',
    key: 'origin',
    ellipsis: true,
    width: 100,
    render: (v, all) => {
      if (all.empty) {
        return <div className="daf-default-cell md" />;
      }

      return v;
    }
  },
];
